import React from "react";
import { Box, Button, Hidden, Inline } from "@origin-digital/ods-core";
import { IconPlus } from "@origin-digital/ods-icons";
import { ActionSectionProps } from "./types";
import { SearchFieldResponsive } from "src/components/Form/SearchField";
import { useActionSection } from "./useActionSection";
import { useSearchAction } from "src/context/NewPremiseFormContext";

export const ActionSection = (props: ActionSectionProps) => {
  const { newProjectButtonProps } = useActionSection(props);

  const { searchFieldProps } = useSearchAction();
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={["medium", "large"]}
      data-id="actionSection.root"
    >
      {/* Actions inner container */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{
          xs: "row",
          lg: "row-reverse",
        }}
      >
        {/* New project */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap="small"
          data-id="actionSection.newProjectButtonBox"
        >
          <Button
            size="small"
            icon={<IconPlus color="inherit" />}
            {...newProjectButtonProps}
          >
            <Inline>
              <Hidden below="lg">New project</Hidden>
              <Hidden above="lg">New</Hidden>
            </Inline>
          </Button>
        </Box>
        {/* End New project */}
        {/* Search */}
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          flexDirection={{
            xs: "row",
            lg: "row-reverse",
          }}
          gap={{
            xs: "xxxsmall",
            md: "medium",
          }}
          data-id="actionSection.searchFieldBox"
        >
          {/* Search (LG > XL) */}
          <SearchFieldResponsive {...searchFieldProps} />
          {/* End Search (LG > XL) */}
          {/* End Search (XS > MD) */}
        </Box>
        {/* End Search */}
      </Box>
      {/* End Actions inner container */}
    </Box>
  );
};
